import { useNavigate } from "react-router-dom";
import { Card, CardActionArea, CardContent, Typography, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListIcon from "@mui/icons-material/List";

export default function DoctorHomePage() {
  const navigate = useNavigate();

  const items = [
    {
      icon: <SearchIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Найти пациента",
      subtitle: "Поиск по ID",
      path: "/doctor/find-patient",
    },
    {
      icon: <PersonAddIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Создать пациента",
      subtitle: "Новая регистрация",
      path: "/doctor/create-patient",
    },
    {
      icon: <ListIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Все пациенты",
      subtitle: "Список пациентов",
      path: "/doctor/my-patients",
    },
  ];

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <Typography variant="h5" sx={{ textAlign: "center" }}>
        Пациенты
      </Typography>

      {items.map((item) => (
        <Card key={item.path}>
          <CardActionArea onClick={() => navigate(item.path)}>
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, py: 2 }}>
              {item.icon}
              <div>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {item.subtitle}
                </Typography>
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  );
}
